import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  NotEmptyList__toString_impl_vyyy953tw060zmkvhkj as NotEmptyList__toString_impl_vyyy95,
  NotEmptyList__hashCode_impl_a7t1ga1icu5nxpmmumo as NotEmptyList__hashCode_impl_a7t1ga,
} from '../../../../../types-types/kotools/types/collection/NotEmptyList.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SuccessClass;
function Success() {
  if (SuccessClass === VOID) {
    class $ {
      toString() {
        return 'Success';
      }
      hashCode() {
        return 2094357148;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Success()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'Success');
    SuccessClass = $;
  }
  return SuccessClass;
}
var Success_instance;
function Success_getInstance() {
  return Success_instance;
}
var DispatcherClass;
function Dispatcher() {
  if (DispatcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Dispatcher', VOID, VOID, VOID, [1]);
    DispatcherClass = $;
  }
  return DispatcherClass;
}
var SpinCommandClass;
function SpinCommand() {
  if (SpinCommandClass === VOID) {
    class $ {
      constructor(partyId, playerIds, pinIds) {
        this.r2j_1 = partyId;
        this.s2j_1 = playerIds;
        this.t2j_1 = pinIds;
      }
      toString() {
        return 'SpinCommand(partyId=' + this.r2j_1.toString() + ', playerIds=' + NotEmptyList__toString_impl_vyyy95(this.s2j_1) + ', pinIds=' + toString(this.t2j_1) + ')';
      }
      hashCode() {
        var result = this.r2j_1.hashCode();
        result = imul(result, 31) + NotEmptyList__hashCode_impl_a7t1ga(this.s2j_1) | 0;
        result = imul(result, 31) + hashCode(this.t2j_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SpinCommand()))
          return false;
        if (!this.r2j_1.equals(other.r2j_1))
          return false;
        if (!equals(this.s2j_1, other.s2j_1))
          return false;
        if (!equals(this.t2j_1, other.t2j_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SpinCommand');
    SpinCommandClass = $;
  }
  return SpinCommandClass;
}
//region block: init
Success_instance = new (Success())();
//endregion
//region block: exports
export {
  Dispatcher as Dispatchernurlbopdkn3a,
  SpinCommand as SpinCommandit59wq02zpmd,
  Success_instance as Success_instance2p306gayageh9,
};
//endregion

//# sourceMappingURL=SpinCommand.mjs.map
